import { Chip } from "@mui/material";
import type { EbookStatus } from "@ebook/contracts";
import { useTranslate } from "../i18n";

const labels: Record<EbookStatus, string> = {
  draft: "Draft",
  uploading: "Uploading",
  queued: "Queued",
  processing: "Processing",
  ready: "Ready",
  failed: "Failed",
};

export function StatusChip({ status }: { status: EbookStatus }) {
  const __ = useTranslate();
  return <Chip
    size="small"
    label={__(labels[status])}
    color={status === "ready" ? "success" : status === "failed" ? "error" : status === "draft" ? "default" : "primary"}
    variant={status === "draft" ? "outlined" : "filled"}
  />;
}
